import { map, tryFindIndex } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { float64_type, option_type, class_type, union_type, record_type, array_type, lambda_type, unit_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { loadEffect, LoadState$2, LoadState$2$reflection } from "../../Global.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { dotsLoading } from "../../ViewUtils.js";
import { error } from "../Message/Message.js";
import * as react from "react";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { delayAsync, createThrottle } from "../../Utils.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_2 } from "../StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import "../../../src/Components/SearchSuggestion/SearchSuggestion.scss";


function getFilteredSuggestions(suggestions, input) {
    let index;
    const startIndexOpt = tryFindIndex((n) => (n.indexOf(input) === 0), suggestions);
    const matchValue = [(startIndexOpt == null) ? false : ((index = (startIndexOpt | 0), suggestions[index] === input)), startIndexOpt];
    let pattern_matching_result;
    if (matchValue[0]) {
        pattern_matching_result = 0;
    }
    else if (matchValue[1] != null) {
        pattern_matching_result = 1;
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [];
        }
        case 1: {
            const startIndex = matchValue[1] | 0;
            let endIndex;
            const arrayMaxIndex = (suggestions.length - 1) | 0;
            const startPlusFiveIndex = (startIndex + 4) | 0;
            endIndex = ((startPlusFiveIndex > arrayMaxIndex) ? arrayMaxIndex : startPlusFiveIndex);
            return suggestions.slice(startIndex, endIndex + 1);
        }
    }
}

class SuggestionsProps extends Record {
    constructor(Value, OnClick, SuggestionsLoadState) {
        super();
        this.Value = Value;
        this.OnClick = OnClick;
        this.SuggestionsLoadState = SuggestionsLoadState;
    }
}

function SuggestionsProps$reflection() {
    return record_type("Components.SearchSuggestion.SuggestionsProps", [], SuggestionsProps, () => [["Value", string_type], ["OnClick", lambda_type(string_type, unit_type)], ["SuggestionsLoadState", LoadState$2$reflection(array_type(string_type), string_type)]]);
}

const renderSuggestions = FunctionComponent_Of_Z5A158BBF((props) => {
    let containerContentHtml;
    const matchValue = props.SuggestionsLoadState;
    switch (matchValue.tag) {
        case 1: {
            containerContentHtml = dotsLoading;
            break;
        }
        case 3: {
            containerContentHtml = error(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            const children_3 = map((txt) => react.createElement("li", {
                className: "list__item",
                onClick: (_arg) => {
                    props.OnClick(txt);
                },
            }, txt), getFilteredSuggestions(matchValue.fields[0], props.Value));
            containerContentHtml = react.createElement("ul", {
                className: "container__list",
            }, ...children_3);
            break;
        }
        default: {
            containerContentHtml = react.createElement(react.Fragment, {});
        }
    }
    return react.createElement("div", {
        className: "suggestion__container",
    }, containerContentHtml);
}, "Suggestions", uncurry(2, void 0), void 0, "renderSuggestions", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\SearchSuggestion\\SearchSuggestion.fs", 51);

export class SearchSuggestionProps$1 extends Record {
    constructor(SearchFn, SearchValue, OnChangeSearchValue, LabelText, Id, ValidationFn, ThrottleSearchMs) {
        super();
        this.SearchFn = SearchFn;
        this.SearchValue = SearchValue;
        this.OnChangeSearchValue = OnChangeSearchValue;
        this.LabelText = LabelText;
        this.Id = Id;
        this.ValidationFn = ValidationFn;
        this.ThrottleSearchMs = ThrottleSearchMs;
    }
}

export function SearchSuggestionProps$1$reflection(gen0) {
    return record_type("Components.SearchSuggestion.SearchSuggestionProps`1", [gen0], SearchSuggestionProps$1, () => [["SearchFn", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(string_type), string_type], FSharpResult$2, () => [[["ResultValue", array_type(string_type)]], [["ErrorValue", string_type]]])]))], ["SearchValue", string_type], ["OnChangeSearchValue", lambda_type(string_type, unit_type)], ["LabelText", string_type], ["Id", string_type], ["ValidationFn", option_type(lambda_type(string_type, union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, string_type], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", string_type]]])))], ["ThrottleSearchMs", option_type(float64_type)]]);
}

function render$0027(props) {
    let inputRecord;
    const searchResultState = react.useState(new LoadState$2(0));
    const inputFocusedState = react.useState(false);
    const throttleFn = react.useMemo(() => {
        const matchValue = props.ThrottleSearchMs;
        return (matchValue == null) ? createThrottle(0) : createThrottle(matchValue);
    }, [props.ThrottleSearchMs]);
    const inputHtml = render_2()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(props.SearchValue, inputRecord.Type, inputRecord.Classes, (e) => {
        props.OnChangeSearchValue(Browser_Types_Event__Event_get_Value(e));
        throttleFn(() => {
            const searchText = Browser_Types_Event__Event_get_Value(e);
            loadEffect(() => props.SearchFn(searchText), (arg) => {
                searchResultState[1](arg);
            });
        });
    }, inputRecord.Disabled, props.LabelText, props.Id, props.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, (_arg_1) => {
        startImmediate(delayAsync(500, () => {
            inputFocusedState[1](false);
        }));
    }, (_arg) => {
        inputFocusedState[1](true);
    }, "off", inputRecord.Name)));
    let suggestionsHtml;
    const matchValue_1 = inputFocusedState[0];
    suggestionsHtml = (matchValue_1 ? renderSuggestions(new SuggestionsProps(props.SearchValue, (suggestion) => {
        props.OnChangeSearchValue(suggestion);
        inputFocusedState[1](false);
    }, searchResultState[0])) : react.createElement(react.Fragment, {}));
    return react.createElement("div", {
        className: "search-suggestion",
    }, inputHtml, suggestionsHtml);
}

export function render() {
    return FunctionComponent_Of_Z5A158BBF(render$0027, void 0, uncurry(2, void 0), void 0, "render", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\SearchSuggestion\\SearchSuggestion.fs", 119);
}

